import React, { useState } from "react";
import Common_Headings from "../common_components/common_heading/Common_Headings";
import Common_Expert_Card from "../common_components/common-expert-card/Common_Expert_Card";
import Call_Now_Expert_Modal from "../common_components/common-modals/call-now-expert-modal/Call_Now_Expert_Modal";
import Send_Btn_Expert_Modal from "../common_components/common-modals/send-btn-expert-modal/Send_Btn_Expert_Modal";
import Pagination_Holder from "../common_components/pagination-holder/Pagination_Holder";

const expertData = [
  {
    id: 1,
    name: "Rajesh Kumar",
    location: "Pune, Maharashtra",
    field: "Carpainter",
    experience: "6 Years",
    age: 28,
    rating: "⭐4.5/5",
    rating: "⭐4.5/5",
    availability: "Available Today",
    service: "Free Site Visit",
    img: "/assets/images/expert1.png",
    verified: true,
  },
  {
    id: 2,
    name: "Prakash More",
    location: "Pune, Maharashtra",
    field: "Plumbing Repair",
    experience: "6 Years",
    age: 28,
    rating: "⭐4.5/5",
    availability: "Available Today",
    service: "Free Site Visit",
    img: "/assets/images/expert2.png",
    verified: true,
  },
  {
    id: 3,
    name: "Ashwin Rana",
    location: "Pune, Maharashtra",
    field: "Carpainter",
    experience: "6 Years",
    age: 28,
    rating: "⭐4.5/5",
    availability: "Available Today",
    service: "Free Site Visit",
    img: "/assets/images/expert1.png",
    verified: true,
  },
  {
    id: 4,
    name: "Rajesh Kumar",
    location: "Pune, Maharashtra",
    field: "Carpainter",
    experience: "6 Years",
    age: 28,
    rating: "⭐4.5/5",
    availability: "Available Today",
    service: "Free Site Visit",
    img: "/assets/images/expert1.png",
    verified: true,
  },
  {
    id: 5,
    name: "Prakash More",
    location: "Pune, Maharashtra",
    field: "Plumbing Repair",
    experience: "6 Years",
    age: 28,
    rating: "⭐4.5/5",
    availability: "Available Today",
    service: "Free Site Visit",
    img: "/assets/images/expert2.png",
    verified: true,
  },
  {
    id: 6,
    name: "Ashwin Rana",
    location: "Pune, Maharashtra",
    field: "Carpainter",
    experience: "6 Years",
    age: 28,
    rating: "⭐4.5/5",
    availability: "Available Today",
    service: "Free Site Visit",
    img: "/assets/images/expert1.png",
    verified: true,
  },
  {
    id: 7,
    name: "Rajesh Kumar",
    location: "Pune, Maharashtra",
    field: "Carpainter",
    experience: "6 Years",
    age: 28,
    rating: "⭐4.5/5",
    availability: "Available Today",
    service: "Free Site Visit",
    img: "/assets/images/expert1.png",
    verified: true,
  },
  {
    id: 8,
    name: "Prakash More",
    location: "Pune, Maharashtra",
    field: "Plumbing Repair",
    experience: "6 Years",
    age: 28,
    rating: "⭐4.5/5",
    availability: "Available Today",
    service: "Free Site Visit",
    img: "/assets/images/expert2.png",
    verified: true,
  },
  {
    id: 9,
    name: "Ashwin Rana",
    location: "Pune, Maharashtra",
    field: "Carpainter",
    experience: "6 Years",
    age: 28,
    rating: "⭐4.5/5",
    availability: "Available Today",
    service: "Free Site Visit",
    img: "/assets/images/expert1.png",
    verified: true,
  },

  {
    id: 10,
    name: "Rajesh Kumar",
    location: "Pune, Maharashtra",
    field: "Painter",
    experience: "5 Years",
    age: 30,
    rating: "⭐4.5/5",
    availability: "Available Today",
    service: "Free Site Visit",
    img: "/assets/images/expert1.png",
    verified: true,
  },
  {
    id: 11,
    name: "Prakash More",
    location: "Pune, Maharashtra",
    field: "Electrician",
    experience: "5 Years",
    age: 30,
    rating: "⭐4.5/5",
    availability: "Available Today",
    service: "Free Site Visit",
    img: "/assets/images/expert2.png",
    verified: true,
  },
  {
    id: 12,
    name: "Ashwin Rana",
    location: "Pune, Maharashtra",
    field: "Painter",
    experience: "5 Years",
    age: 30,
    rating: "⭐4.5/5",
    availability: "Available Today",
    service: "Free Site Visit",
    img: "/assets/images/expert1.png",
    verified: true,
  },
  {
    id: 13,
    name: "Rajesh Kumar",
    location: "Pune, Maharashtra",
    field: "Painter",
    experience: "5 Years",
    age: 30,
    rating: "⭐4.5/5",
    availability: "Available Today",
    service: "Free Site Visit",
    img: "/assets/images/expert1.png",
    verified: true,
  },
  {
    id: 14,
    name: "Prakash More",
    location: "Pune, Maharashtra",
    field: "Electrician",
    experience: "5 Years",
    age: 30,
    rating: "⭐4.5/5",
    availability: "Available Today",
    service: "Free Site Visit",
    img: "/assets/images/expert2.png",
    verified: true,
  },
  {
    id: 15,
    name: "Ashwin Rana",
    location: "Pune, Maharashtra",
    field: "Painter",
    experience: "5 Years",
    age: 30,
    rating: "⭐4.5/5",
    availability: "Available Today",
    service: "Free Site Visit",
    img: "/assets/images/expert1.png",
    verified: true,
  },
  {
    id: 16,
    name: "Rajesh Kumar",
    location: "Pune, Maharashtra",
    field: "Painter",
    experience: "5 Years",
    age: 30,
    rating: "⭐4.5/5",
    availability: "Available Today",
    service: "Free Site Visit",
    img: "/assets/images/expert1.png",
    verified: true,
  },
  {
    id: 17,
    name: "Prakash More",
    location: "Pune, Maharashtra",
    field: "Electrician",
    experience: "5 Years",
    age: 30,
    rating: "⭐4.5/5",
    availability: "Available Today",
    service: "Free Site Visit",
    img: "/assets/images/expert2.png",
    verified: true,
  },
  {
    id: 18,
    name: "Ashwin Rana",
    location: "Pune, Maharashtra",
    field: "Painter",
    experience: "5 Years",
    age: 30,
    rating: "⭐4.5/5",
    availability: "Available Today",
    service: "Free Site Visit",
    img: "/assets/images/expert1.png",
    verified: true,
  },

  {
    id: 19,
    name: "Rajesh Kumar",
    location: "Pune",
    field: "Painter",
    experience: "4 Years",
    age: 25,
    rating: "⭐4.5/5",
    availability: "Available Today",
    service: "Free Site Visit",
    img: "/assets/images/expert1.png",
    verified: true,
  },
  {
    id: 20,
    name: "Prakash More",
    location: "Pune",
    field: "Painter",
    experience: "4 Years",
    age: 25,
    rating: "⭐4.5/5",
    availability: "Available Today",
    service: "Free Site Visit",
    img: "/assets/images/expert2.png",
    verified: true,
  },
  {
    id: 21,
    name: "Ashwin Rana",
    location: "Pune",
    field: "Painter",
    experience: "4 Years",
    age: 25,
    rating: "⭐4.5/5",
    availability: "Available Today",
    service: "Free Site Visit",
    img: "/assets/images/expert1.png",
    verified: true,
  },
  {
    id: 22,
    name: "Rajesh Kumar",
    location: "Pune",
    field: "Painter",
    experience: "4 Years",
    age: 25,
    rating: "⭐4.5/5",
    availability: "Available Today",
    service: "Free Site Visit",
    img: "/assets/images/expert1.png",
    verified: true,
  },
  {
    id: 23,
    name: "Prakash More",
    location: "Pune",
    field: "Painter",
    experience: "4 Years",
    age: 25,
    rating: "⭐4.5/5",
    availability: "Available Today",
    service: "Free Site Visit",
    img: "/assets/images/expert2.png",
    verified: true,
  },
  {
    id: 24,
    name: "Ashwin Rana",
    location: "Pune",
    field: "Painter",
    experience: "4 Years",
    age: 25,
    rating: "⭐4.5/5",
    availability: "Available Today",
    service: "Free Site Visit",
    img: "/assets/images/expert1.png",
    verified: true,
  },
  {
    id: 25,
    name: "Rajesh Kumar",
    location: "Pune",
    field: "Painter",
    experience: "4 Years",
    age: 25,
    rating: "⭐4.5/5",
    availability: "Available Today",
    service: "Free Site Visit",
    img: "/assets/images/expert1.png",
    verified: true,
  },
  {
    id: 26,
    name: "Prakash More",
    location: "Pune",
    field: "Painter",
    experience: "4 Years",
    age: 25,
    rating: "⭐4.5/5",
    availability: "Available Today",
    service: "Free Site Visit",
    img: "/assets/images/expert2.png",
    verified: true,
  },
  {
    id: 27,
    name: "Ashwin Rana",
    location: "Pune",
    field: "Painter",
    experience: "4 Years",
    age: 25,
    rating: "⭐4.5/5",
    availability: "Available Today",
    service: "Free Site Visit",
    img: "/assets/images/expert1.png",
    verified: true,
  },

  {
    id: 28,
    name: "Rajesh Kumar",
    location: "Pune",
    field: "Painter",
    experience: "10 Years",
    age: 40,
    rating: "⭐4.5/5",
    availability: "Available Today",
    service: "Free Site Visit",
    img: "/assets/images/expert1.png",
    verified: true,
  },
  {
    id: 29,
    name: "Prakash More",
    location: "Pune",
    field: "Painter",
    experience: "10 Years",
    age: 40,
    rating: "⭐4.5/5",
    availability: "Available Today",
    service: "Free Site Visit",
    img: "/assets/images/expert1.png",
    verified: true,
  },
  {
    id: 30,
    name: "Ashwin Rana",
    location: "Pune",
    field: "Painter",
    experience: "10 Years",
    age: 40,
    rating: "⭐4.5/5",
    availability: "Available Today",
    service: "Free Site Visit",
    img: "/assets/images/expert1.png",
    verified: true,
  },
  {
    id: 31,
    name: "Rajesh Kumar",
    location: "Pune",
    field: "Painter",
    experience: "10 Years",
    age: 40,
    rating: "⭐4.5/5",
    availability: "Available Today",
    service: "Free Site Visit",
    img: "/assets/images/expert1.png",
    verified: true,
  },
  {
    id: 32,
    name: "Prakash More",
    location: "Pune",
    field: "Painter",
    experience: "10 Years",
    age: 40,
    rating: "⭐4.5/5",
    availability: "Available Today",
    service: "Free Site Visit",
    img: "/assets/images/expert1.png",
    verified: true,
  },
  {
    id: 33,
    name: "Ashwin Rana",
    location: "Pune",
    field: "Painter",
    experience: "10 Years",
    age: 40,
    rating: "⭐4.5/5",
    availability: "Available Today",
    service: "Free Site Visit",
    img: "/assets/images/expert1.png",
    verified: true,
  },
  {
    id: 34,
    name: "Rajesh Kumar",
    location: "Pune",
    field: "Painter",
    experience: "10 Years",
    age: 40,
    rating: "⭐4.5/5",
    availability: "Available Today",
    service: "Free Site Visit",
    img: "/assets/images/expert1.png",
    verified: true,
  },
  {
    id: 35,
    name: "Prakash More",
    location: "Pune",
    field: "Painter",
    experience: "10 Years",
    age: 40,
    rating: "⭐4.5/5",
    availability: "Available Today",
    service: "Free Site Visit",
    img: "/assets/images/expert1.png",
    verified: true,
  },
  {
    id: 36,
    name: "Ashwin Rana",
    location: "Pune",
    field: "Painter",
    experience: "10 Years",
    age: 40,
    rating: "⭐4.5/5",
    availability: "Available Today",
    service: "Free Site Visit",
    img: "/assets/images/expert1.png",
    verified: true,
  },
];

const Expert_Page = () => {
  const [showInquiry, setShowInquiry] = useState(false);
  const [showCall, setShowCall] = useState(false);

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 9;

  const totalPages = Math.ceil(expertData.length / itemsPerPage);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const paginatedData = expertData.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage,
  );

  return (
    <div className="container mt-4 vendor-section">
      <Common_Headings title="PAINTER EXPERT" />

      <div className="row">
        {paginatedData.map((expert, index) => (
          <div
            key={`${expert.id}-${index}`}
            className="col-12 col-sm-6 col-md-6 col-lg-4 mb-4"
          >
            <Common_Expert_Card
              data={expert}
              onClick3={() => setShowInquiry(true)}
              onClick4={() => setShowCall(true)}
            />
          </div>
        ))}
      </div>
      <div className="row mt-4 mb-5">
        <Pagination_Holder
          onPageChange={currentPage}
          totalPages={totalPages}
          handlePageChange={handlePageChange}
        />
      </div>

      <Send_Btn_Expert_Modal
        show={showInquiry}
        handleClose={() => setShowInquiry(false)}
      />
      <Call_Now_Expert_Modal
        show={showCall}
        handleClose={() => setShowCall(false)}
      />
    </div>
  );
};

export default Expert_Page;
